import { findProjectBySlug } from "./projects";

export interface Post {
  slug: string;
  title: string;
  excerpt: string;
  date: string; // ISO 8601
  readingMinutes: number;
  tags: readonly string[];
  relatedProjectSlug?: string;
  coverImageKey?: string;
}

export const POSTS: readonly Post[] = [
  {
    slug: "grounding-ai-assistant-product-knowledge",
    title: "Grounding an on-site AI assistant in real product knowledge",
    excerpt:
      "How we wired a Claude-powered chat widget into the Devbloom site's own content — rate limiting, i18n, and RAG-lite in a single Vercel serverless function.",
    date: "2026-05-28",
    readingMinutes: 7,
    tags: ["AI", "Claude", "RAG", "Serverless", "Node.js"],
    relatedProjectSlug: "bloom-assistant",
  },
  {
    slug: "offline-first-multiplayer-expo-multipeer",
    title: "Offline-first multiplayer on iOS with Expo + Multipeer",
    excerpt:
      "Building a custom Multipeer Connectivity native module for Expo to sync two iPhones as a drag-racing start tree — no Wi-Fi, no server, millisecond precision.",
    date: "2026-04-15",
    readingMinutes: 8,
    tags: ["iOS", "Expo", "Multipeer", "React Native", "Native Modules"],
    relatedProjectSlug: "staged",
  },
  {
    slug: "shelter-ops-pwa-gemini",
    title: "Building a shelter-operations PWA with Gemini",
    excerpt:
      "How Patitas connects Colombian animal shelters with monthly sponsors — recurring COP payments via Wompi, AI-generated animal profiles with Gemini, and an offline-capable PWA on Firebase.",
    date: "2026-03-10",
    readingMinutes: 9,
    tags: ["PWA", "Gemini", "Firebase", "Wompi", "Colombia"],
    relatedProjectSlug: "patitas",
  },
] as const;

export function findPostBySlug(slug: string): Post | undefined {
  return POSTS.find((p) => p.slug === slug);
}

// Validate at module load that every relatedProjectSlug resolves.
// This turns a data mistake into a loud import-time error rather than a
// silent broken link in production.
if (process.env.NODE_ENV !== "production") {
  for (const post of POSTS) {
    if (
      post.relatedProjectSlug &&
      !findProjectBySlug(post.relatedProjectSlug)
    ) {
      throw new Error(
        `posts.ts: relatedProjectSlug "${post.relatedProjectSlug}" on post "${post.slug}" does not exist in projects.ts`
      );
    }
  }
}
